import React, { useState, useEffect } from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dimmer, Loader } from 'semantic-ui-react';
import { ProposalSelectCustomerModal } from '../create/ProposalSelectCustomerModal';
import { AddButton } from '../../../components/AddButton/AddButton';
import { useProposals } from '../../../providers/ProposalProvider';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Proposals';

export const ProposalList = () => {
    const { checkAuth, getUserType } = useAuth();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const { total, pageIndex, setPageIndex, pageSize, setPageSize, proposals, getProposals, sortState, setSortState } = useProposals();
    const navigate = useNavigate();

    if (getUserType() !== null) {
        checkAuth(getUserType(), WEB_PAGE) && navigate('/');
    }

    useEffect(() => {
        setLoading(true);
        const fetchProposals = async () => {
            await getProposals();
            setLoading(false);
        };

        fetchProposals();
    }, [getProposals, pageSize, pageIndex]);

    const handlePageChange = (e) => {
        setPageIndex(e.page.skip / e.page.take);
    };

    const handleSortChange = (e) => {
        setSortState(e.sort.length ? [{ fieldName: e.sort[0].field, dir: e.sort[0].dir }] : []);
    };

    const sort = sortState.map(s => ({ field: s.fieldName, dir: s.dir }));

    return (
        <div>
            <ProposalSelectCustomerModal open={open} setOpen={setOpen} />
            <div className="pageHeader">
                <h1>Proposals</h1>
                <AddButton onClick={() => setOpen(true)}>Create a Proposal</AddButton>
            </div>
            <div style={{ position: 'relative' }}>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                <Grid
                    data={proposals}
                    total={total}
                    skip={pageIndex * pageSize}
                    take={pageSize}
                    pageable={true}
                    sortable={true}
                    sort={sort}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    onRowClick={(e) => navigate(`/proposals/edit/${e.dataItem.id}`)}
                >
                    <Column
                        field="timestamp"
                        title="Date"
                        cell={props => <td>{new Date(props.dataItem.timestamp).toLocaleDateString()}</td>}
                    />
                    <Column
                        field="name"
                        title="Proposal Name"
                        cell={props => <td>{props.dataItem.name ?? ''}</td>}
                    />
                    <Column
                        field="customer.companyName"
                        title="Customer"
                        cell={props => <td style={{ textAlign: 'left' }}>{props.dataItem.customer.companyName}</td>}
                    />
                </Grid>
            </div>
        </div>
    );
};
